import { render } from "./pb-pageformattext.vue?vue&type=template&id=be115b4c"
import script from "./pb-pageformattext.vue?vue&type=script&lang=js"
export * from "./pb-pageformattext.vue?vue&type=script&lang=js"

import "./pb-pageformattext.vue?vue&type=style&index=0&id=be115b4c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__